import { render, staticRenderFns } from "./SectionEditorDialog.vue?vue&type=template&id=08e620e2&scoped=true"
import script from "./SectionEditorDialog.vue?vue&type=script&lang=js"
export * from "./SectionEditorDialog.vue?vue&type=script&lang=js"
import style0 from "./SectionEditorDialog.vue?vue&type=style&index=0&id=08e620e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e620e2",
  null
  
)

export default component.exports